export default (to, from, next) => {
  if (to.name == 'Settings') {
    var hasFullService = window.sessionStorage.getItem('hasFullService');
    return hasFullService === 'true' ? next() : next('/');
  }
  return next();
};
